import React, { useContext } from 'react';
import SignUpForm from '../Sign/SignUpForm';
import SignInForm from '../Sign/SignInForm';
import { UserContext } from '../context/UserContext';

function Cover() {
  return (
    <div className="signForm">
      <SignUpForm />
      <SignInForm />
    </div>
  );
}

function AuthGuard({ children }) {
  const { isLoggedIn, isInitialized } = useContext(UserContext);
  return isInitialized ? isLoggedIn ? children : <Cover /> : null;
}

export default AuthGuard;
